import { render } from "./MemoryMuse.vue?vue&type=template&id=26a077ab"
import script from "./MemoryMuse.vue?vue&type=script&lang=js"
export * from "./MemoryMuse.vue?vue&type=script&lang=js"

import "./MemoryMuse.vue?vue&type=style&index=0&id=26a077ab&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__